import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { TagActions } from '../../../store/actions/tags';

import Select from '../../Select';

const SelectTags = ({ onSelect, match }) => {
  const [selectedValues, setSectedValues] = useState([]);

  const { tags } = useSelector((state) => state.tags.tagsState);
  const { currentItem } = useSelector((state) => state.items);

  const dispatch = useDispatch();
  const { botid: botId } = match.params;

  useEffect(() => {
    if (currentItem && currentItem.tags) {
      setSectedValues(() =>
        currentItem.tags.map((tag) => ({
          value: tag,
          label: tag,
        }))
      );
    } else {
      setSectedValues([]);
    }
  }, [currentItem]);

  const formattedBotTagsOptions = useMemo(() => {
    return tags && tags.bot
      ? tags.bot.map((tag) => ({
          value: tag.name,
          label: tag.name,
        }))
      : [];
  }, [tags]);

  const formattedGlobalTagsOptions = useMemo(() => {
    return tags && tags.global
      ? tags.global.map((tag) => ({
          value: `${tag.type}.${tag.name}`,
          label: `${tag.type}.${tag.name}`,
        }))
      : [];
  }, [tags]);

  const formattedGroupedOptions = useMemo(() => {
    return [
      {
        label: 'Suas tags',
        options: formattedBotTagsOptions,
      },
      {
        label: 'Tags padrão',
        options: formattedGlobalTagsOptions,
      },
    ];
  }, [formattedBotTagsOptions, formattedGlobalTagsOptions]);

  const handleChange = useCallback(
    (values) => {
      if (values) {
        setSectedValues(values);

        const formattedTagsToSubmit = values.map((tag) => tag.value);
        onSelect(formattedTagsToSubmit);
      } else {
        setSectedValues([]);
        onSelect([]);
      }
    },
    [onSelect]
  );

  const handleCreate = useCallback(
    (inputValue) => {
      const payload = [{ botId, name: inputValue, active: true, type: 'user' }];
      dispatch(TagActions.create({ values: payload }));

      setSectedValues([
        ...selectedValues,
        { label: inputValue, value: inputValue },
      ]);

      if (!currentItem.tags) {
        currentItem.tags = [];
      }

      onSelect([...currentItem.tags, inputValue]);
    },
    [botId, selectedValues, currentItem]
  );

  return (
    <Select
      label="Tags"
      options={formattedGroupedOptions}
      value={selectedValues}
      onChange={handleChange}
      onCreateOption={handleCreate}
      isMulti
      isCreatable
      className="p-2"
      inputMaxLength={50}
    />
  );
};

export default SelectTags;
